/**
 * Rollback Tool Schema
 * 
 * Schema for rolling back to a previous checkpoint.
 * Used by ExecutionAgent when a build result looks incorrect.
 */

import { z } from "zod";

// ═══════════════════════════════════════════════════════════════════════════
// ROLLBACK PARAMS
// ═══════════════════════════════════════════════════════════════════════════

export const RollbackParamsSchema = z.object({
    checkpointId: z.string().describe(
        "The checkpoint ID to rollback to. Can be a 5-digit area ID (e.g., '12345') " +
        "or a section checkpoint (e.g., 'section_0_before', 'section_0_after')."
    ),
    reason: z.string().describe(
        "Explanation of why the rollback is needed (for logging and debugging)."
    ),
});

export type RollbackParams = z.infer<typeof RollbackParamsSchema>;

// ═══════════════════════════════════════════════════════════════════════════
// ROLLBACK RESPONSE
// ═══════════════════════════════════════════════════════════════════════════

export const RollbackResponseSchema = z.object({
    success: z.boolean(),
    rolledBackTo: z.string().describe("The checkpoint ID that was restored"),
    message: z.string().describe("Status message"),
    error: z.string().nullable().optional(),
});

export type RollbackResponse = z.infer<typeof RollbackResponseSchema>;

